import { create } from 'zustand';
import type { Tournament, TournamentDetail } from '../engine/types';
import { tournaments as api } from '../lib/api';

interface TournamentStoreState {
  list: Tournament[];
  current: TournamentDetail | null;
  loading: boolean;
  error: string | null;

  loadAll: () => Promise<void>;
  loadOne: (id: number) => Promise<void>;
  refresh: () => Promise<void>;
  setCurrent: (detail: TournamentDetail | null) => void;
  reset: () => void;
}

export const useTournamentStore = create<TournamentStoreState>((set, get) => ({
  list: [],
  current: null,
  loading: false,
  error: null,

  loadAll: async () => {
    set({ loading: true, error: null });
    try {
      const list = await api.getAll();
      set({ list, loading: false });
    } catch (e) {
      set({ error: String(e), loading: false });
    }
  },

  loadOne: async (id) => {
    set({ loading: true, error: null });
    try {
      const current = await api.getById(id);
      set({ current, loading: false });
    } catch (e) {
      set({ error: String(e), loading: false });
    }
  },

  refresh: async () => {
    const { current } = get();
    if (!current) return;
    try {
      const updated = await api.getById(current.id);
      set({ current: updated });
    } catch (e) {
      set({ error: String(e) });
    }
  },

  setCurrent: (detail) => set({ current: detail }),

  reset: () => set({ list: [], current: null, loading: false, error: null }),
}));
